import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["accept", "children", "onFileSelect", "onClick", "disabled", "small", "wide", "primary", "secondary", "tertiary", "danger"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useRef } from 'react';
import { useRootRef } from '../../../system';
export var useFileUploadButton = function useFileUploadButton(_ref, ref) {
  var accept = _ref.accept,
      children = _ref.children,
      onFileSelect = _ref.onFileSelect,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      small = _ref.small,
      wide = _ref.wide,
      primary = _ref.primary,
      secondary = _ref.secondary,
      tertiary = _ref.tertiary,
      danger = _ref.danger,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var rootRef = useRootRef(ref);
  var internalInputRef = useRef(null);
  var handleClick = useCallback(function (event) {
    if (!internalInputRef.current) {
      return;
    }

    var node = internalInputRef.current;

    if (onClick) {
      onClick(event);
    }

    if (!node || disabled) {
      return;
    }

    node.click();
  }, [disabled, onClick]);
  var handleChange = useCallback(function (event) {
    var target = event.target;

    if (onFileSelect && target) {
      var file = target.files[0];
      onFileSelect(file);
    }
  }, [onFileSelect]);
  return {
    rootProps: _objectSpread(_objectSpread({}, restProps), {}, {
      ref: rootRef
    }),
    buttonProps: {
      disabled: disabled,
      small: small,
      wide: wide,
      primary: primary,
      secondary: secondary,
      tertiary: tertiary,
      danger: danger,
      onClick: handleClick
    },
    fileInputProps: {
      accept: accept,
      type: 'file',
      hidden: true,
      onChange: handleChange,
      ref: internalInputRef
    },
    children: children
  };
};